// extracted by mini-css-extract-plugin
export default {"loginBox":"styles_loginBox__N5yvF"};